import { StyleSheet, View } from 'react-native';

import { centeredRowContainerStyles } from 'components/ui/centered-row-container';
import { Skeleton } from 'components/ui/skeleton';
import { primitive, spacing } from 'styles/constants';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

export const HistorySkeleton = () => {
  const numColumns = 3;
  const numTransactions = 4;

  return (
    <View style={styles.contentWrapper}>
      <View style={styles.pageContainer}>
        <View style={styles.description}>
          <Skeleton shape="rectangle" style={{ height: 12, width: '80%' }} />
          <Skeleton shape="rectangle" style={{ height: 12, width: '60%', marginTop: 0 }} />
        </View>

        <View style={styles.container}>
          <View style={styles.header}>
            {Array.from({ length: numColumns }).map((_, i) => (
              <Skeleton key={i} shape="rectangle" style={{ width: 87, height: 16 }} />
            ))}
          </View>
          <View>
            {Array.from({ length: numTransactions }).map((_, i) => (
              <View style={styles.transaction} key={i}>
                <Skeleton shape="rectangle" style={{ height: 25, borderRadius: 12 }} />
              </View>
            ))}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  contentWrapper: {
    alignSelf: 'center',
    paddingHorizontal: spacing.$4,
    ...centeredRowContainerStyles.content,
    maxWidth: WEB_SMALL_MAX_WIDTH,
  },
  pageContainer: {
    marginVertical: spacing.$4,
  },
  description: {
    alignItems: 'center',
  },
  container: {
    marginVertical: spacing.$2,
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
    borderRadius: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: spacing.$12,
    borderBottomWidth: 1,
    borderColor: primitive.$blackOpacity10,
    paddingVertical: spacing.$2,
  },
  transaction: {
    padding: spacing.$4,
    borderBottomWidth: 1,
    borderColor: primitive.$blackOpacity10,
  },
});
